import React from "react";

const ServicesCell = ({ row }) => {
  return (
    <div>
      {row.zones?.map((zone, zoneIndex) => (
        <div key={zoneIndex} style={{ marginBottom: "10px" }}>
          {zone?.name && (
            <span style={{ fontWeight: 600 }}>{zone.name} : </span>
          )}
          {zone?.services?.map((service, serviceIndex) => (
            <span key={serviceIndex}>
              {service?.title || service?.serviceTypeName}{" , "}
            </span>
          ))}
          {(!zone?.services || zone.services.length === 0) && <em>no services</em>}
        </div>
      ))}
      {(!row.zones || row.zones.length === 0) && <em>no zones</em>}
    </div>
  );
};

export default ServicesCell;